import { Directive, Input, OnInit } from '@angular/core';
import { ModalService } from '../services/modal.service';
import { IFileViewerFileWithId } from '../components/file-viewer/file-viewer.interface';
import { BaseService } from '../services/base.service';

@Directive({
  selector: '[appPhotoGalleryGroup]',
  standalone: false
})
export class PhotoGalleryGroupDirective implements OnInit {
  @Input('appPhotoGalleryGroup') params: { clickMode?: 'single' | 'double' } = { clickMode: 'double' };
  private files: IFileViewerFileWithId[] = [];

  constructor(
    private modalService: ModalService,
    private baseService: BaseService,
  ) { }

  ngOnInit(): void {
    this.params.clickMode = this.params?.clickMode || 'double';
    if (this.baseService.isMobile) {
      this.params.clickMode = 'single';
    }
  }

  registerGalleryItem(item: IFileViewerFileWithId): void {
    this.files.push(item);
  }

  unregisterGalleryItem(item: IFileViewerFileWithId): void {
    const index = this.files.findIndex(file => file.id === item.id);
    if (index !== -1) {
      this.files.splice(index, 1);
    }
  }

  public openModal(item: IFileViewerFileWithId): void {
    const index = this.files.findIndex(file => file.id === item.id);
    this.modalService.openFileViewer(this.files, index);
  }
}
